import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "../styles/Modal.scss";
import { makeStyles } from "@mui/styles";
import StylistImage from "../assets/imgs/stylists/stylist-image-1.png";
import "../styles/FeaturedStylist.scss";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
    stylistsWrapper: {
        height: "93%",
        overflow: "auto",
        "&::-webkit-scrollbar": {
            display: "none"
        },
        "& .service": {
            marginTop: '.5rem'
        }
    }
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: '30%',
  transform: "translate(-50%, -50%)",
  height: '85vh',
  //   width: 400,
  background:
    "transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 51%, #2992FB 100%) 0% 0% no-repeat padding-box",
  // border: "2px solid #fff",
  boxShadow: "0px 5px 20px #00000040",
  p: 4,
  borderRadius: "16px",
  textAlign: "center",
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#08C4BB",
    },
  },
  typography: {
    fontFamily: [
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    fontSize: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background:
            "transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 44%, #2992FB 100%) 0% 0% no-repeat padding-box",
          borderRadius: "10px",
          opacity: 1,
          height: "48px",
          color: "#fff",
          textTransform: "capitalize",
        },
        "&:hover": {
          // backgroundColor: '#000'
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "primary",
          borderRadius: "16px",
          "&.Mui-checked": {
            color: "#2597F6",
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          border: "1px solid #fff",
          borderRadius: "16px",
          boxShadow: "0px 5px 20px #00000040",
          backdropFilter: "blur(10px)",
        },
      },
    },
  },
});

function StylistModal({ toggleStylistModal, modalOpen = false }) {

    const classes = useStyles();
    const navigate = useNavigate();
    const handleStylistClick = () => {
        navigate('/stylers')
    }

  return (
    <ThemeProvider theme={theme}>
      <>
        <Modal
          open={modalOpen}
          onClose={() => toggleStylistModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="text-center h-100">
              <h3 className="service-modal mb-3">Select Stylist</h3>
              <div className={classes.stylistsWrapper}>
                {/* <Link to="/stylers"> */}
                    <div className="service stylist-wrapper pointer p-3" onClick={handleStylistClick}>
                      <div>
                        <div className="d-flex justify-content-start align-items-center">
                          <img
                            src={StylistImage}
                            alt=""
                            height="64px"
                            width="64px"
                          />
                          <div className="ml-2">
                            <h1 className="fs-20 m-0">John D.</h1>
                          </div>
                        </div>
                        <h3 className="fs-20 text-black">Hair Stylist</h3>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <h3 className="fs-15 text-black">98% positive reviews</h3>
                          <div className="text-center">
                            <h3 className="fs-24 text-black">$40</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                {/* </Link> */}
                <div className="service stylist-wrapper p-3">
                  <div>
                    <div className="d-flex justify-content-start align-items-center">
                      <img
                        src={StylistImage}
                        alt=""
                        height="64px"
                        width="64px"
                      />
                      <div className="ml-2">
                        <h1 className="fs-20 m-0">John D.</h1>
                      </div>
                    </div>
                    <h3 className="fs-20 text-black">Hair Stylist</h3>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <h3 className="fs-15 text-black">98% positive reviews</h3>
                      <div className="text-center">
                        <h3 className="fs-24 text-black">$40</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="service stylist-wrapper p-3">
                  <div>
                    <div className="d-flex justify-content-start align-items-center">
                      <img
                        src={StylistImage}
                        alt=""
                        height="64px"
                        width="64px"
                      />
                      <div className="ml-2">
                        <h1 className="fs-20 m-0">John D.</h1>
                      </div>
                    </div>
                    <h3 className="fs-20 text-black">Hair Stylist</h3>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <h3 className="fs-15 text-black">98% positive reviews</h3>
                      <div className="text-center">
                        <h3 className="fs-24 text-black">$40</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="service stylist-wrapper p-3">
                  <div>
                    <div className="d-flex justify-content-start align-items-center">
                      <img
                        src={StylistImage}
                        alt=""
                        height="64px"
                        width="64px"
                      />
                      <div className="ml-2">
                        <h1 className="fs-20 m-0">John D.</h1>
                      </div>
                    </div>
                    <h3 className="fs-20 text-black">Hair Stylist</h3>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <h3 className="fs-15 text-black">98% positive reviews</h3>
                      <div className="text-center">
                        <h3 className="fs-24 text-black">$40</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="service stylist-wrapper p-3">
                  <div>
                    <div className="d-flex justify-content-start align-items-center">
                      <img
                        src={StylistImage}
                        alt=""
                        height="64px"
                        width="64px"
                      />
                      <div className="ml-2">
                        <h1 className="fs-20 m-0">John D.</h1>
                      </div>
                    </div>
                    <h3 className="fs-20 text-black">Hair Stylist</h3>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <h3 className="fs-15 text-black">98% positive reviews</h3>
                      <div className="text-center">
                        <h3 className="fs-24 text-black">$40</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="service stylist-wrapper p-3">
                  <div>
                    <div className="d-flex justify-content-start align-items-center">
                      <img
                        src={StylistImage}
                        alt=""
                        height="64px"
                        width="64px"
                      />
                      <div className="ml-2">
                        <h1 className="fs-20 m-0">John D.</h1>
                      </div>
                    </div>
                    <h3 className="fs-20 text-black">Hair Stylist</h3>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <h3 className="fs-15 text-black">98% positive reviews</h3>
                      <div className="text-center">
                        <h3 className="fs-24 text-black">$40</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="service stylist-wrapper p-3">
                  <div>
                    <div className="d-flex justify-content-start align-items-center">
                      <img
                        src={StylistImage}
                        alt=""
                        height="64px"
                        width="64px"
                      />
                      <div className="ml-2">
                        <h1 className="fs-20 m-0">John D.</h1>
                      </div>
                    </div>
                    <h3 className="fs-20 text-black">Hair Stylist</h3>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <h3 className="fs-15 text-black">98% positive reviews</h3>
                      <div className="text-center">
                        <h3 className="fs-24 text-black">$40</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      </>
    </ThemeProvider>
  );
}

export default StylistModal;
